/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export function isTextMatchedBySearchQuery( text: string, searchQuery: string ): boolean {
	const separator = /[ -]/g;
	const textTokens = text.toLowerCase().split( separator );
	const searchQueryTokens = searchQuery.toLowerCase().split( separator );

	return searchQueryTokens.every( searchQueryToken => {
		return textTokens.some( textToken => textToken.includes( searchQueryToken ) );
	} );
}
